import React, { useState, useEffect,useRef } from "react";
import {
  Box,
  Heading,
  HStack,
  Flex,
  Text,
  Spinner,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  VStack,
  Center,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Badge,
  InputRightElement,
  IconButton,
  SimpleGrid,
  Grid,
  useDisclosure,
  Icon
} from "@chakra-ui/react";
import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { MdStorefront, MdStore } from "react-icons/md";
import { SearchIcon, CloseIcon } from "@chakra-ui/icons";
import {
  FiShoppingBag,
  FiTag,
  FiPackage,
  FiExternalLink,
  FiChevronLeft,
  FiChevronRight,
  FiMapPin,
  FiHash,
  FiImage,
  FiGrid,
  FiX,
  FiEye,
  FiCheckCircle,
  FiList,
  FiDownload
} from "react-icons/fi";
import apiClient from "../../Configuration/apiClient";
import API_CONFIG from "../../Configuration/apiConfig";
import { Image } from "@chakra-ui/react";
import { InfoCard, ImageCard, ProductTable } from "views/storeReport/cards";

function ViewDetails({ salesOfficer, fromDate, toDate }) {
  const userRole=localStorage.getItem("userRole") ||sessionStorage.getItem("userRole") ||"";
  const isOrgUser=userRole==="ORGIUSER";
  const [searchQuery, setSearchQuery] = useState("");
  const [loadingStores, setLoadingStores] = useState(false);
  const [filteredStores, setFilteredStores] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [pageSize, setPageSize] = useState(100);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedStoreDetails, setSelectedStoreDetails] = useState(null);
  const [scoreBreakdown, setScoreBreakdown] = useState(null);
  const [actualImageUrl, setActualImageUrl] = useState("");
  const [modalActualImages, setModalActualImages] = useState([]);
  const [activationImageUrl, setActivationImageUrl] = useState("");
  const [isActivationImageOpen, setIsActivationImageOpen] = useState(false);
  const [loadingActivationImage, setLoadingActivationImage] = useState(false);
  const [modalImageIndex, setModalImageIndex] = useState(0);
  const [modalAnnotatedImages, setModalAnnotatedImages] = useState([]);
  const [annotatedImageUrl, setAnnotatedImageUrl] = useState("");
  const [stores, setStores] = useState([]);
  const [error, setError] = useState(" ");
  const [productSummary, setProductSummary] = useState([]);
  const [selectedStoreImages, setSelectedStoreImages] = useState([]);
  const [selectedMonthData, setSelectedMonthData] = useState(null);
  const [shelfInfo, setShelfInfo] = useState([]);
  
  const [coolerImageUrl, setCoolerImageUrl] = useState("");
  const [isCoolerImageOpen, setIsCoolerImageOpen] = useState(false);
  const [loadingCoolerImage, setLoadingCoolerImage] = useState(false);

  const presignedUrlCache = useRef({});

  const generatePresignedUrls = async (s3Paths, month, year) => {
  const presignedPromises = s3Paths.map(async (s3Path) => {
    
    const cacheKey = `${s3Path}_${month}_${year}`;
    const cached = presignedUrlCache.current[cacheKey];
    if (cached && Date.now() < cached.expiresAt) {
      return cached.url; 
    }

    const presignedEndpoint = `https://s3service.sconexsoft.com/s3bucket/presigned-url?fileName=${encodeURIComponent(
        s3Path
      )}&bucketName=imageinsightimagesbeverages&operation=download&month=${month}&year=${year}`;
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      const response = await fetch(presignedEndpoint, { signal: controller.signal });
      clearTimeout(timeout);
      if (!response.ok) throw new Error("Failed to fetch presigned URL");
      const presignedUrl = await response.text();
      const trimmed = presignedUrl.trim();

      presignedUrlCache.current[cacheKey] = {
        url: trimmed,
        expiresAt: Date.now() + 50 * 60 * 1000
      };
      return trimmed;
    } catch (err) {
      console.error("Failed to generate presigned URL:", err);
      return null;
    }
  });
    return (await Promise.all(presignedPromises)).filter(Boolean);
 };
  const handlePrevModalImage = () => {
    if (modalImageIndex > 0) {
      const newIndex = modalImageIndex - 1;
      setModalImageIndex(newIndex);
      setActualImageUrl(modalActualImages[newIndex] || "");
      setAnnotatedImageUrl(modalAnnotatedImages[newIndex] || "");

    const prefetchIndex = newIndex - 1;
      [modalActualImages[prefetchIndex], modalAnnotatedImages[prefetchIndex]]
        .filter(Boolean)
        .forEach(src => { new window.Image().src = src; });
    }

  };
  const handleNextModalImage = () => {
    if (modalImageIndex < modalActualImages.length - 1) {
      const newIndex = modalImageIndex + 1;
      setModalImageIndex(newIndex);
      setActualImageUrl(modalActualImages[newIndex] || "");
      setAnnotatedImageUrl(modalAnnotatedImages[newIndex] || "");
    
     const prefetchIndex = newIndex + 1;
      [modalActualImages[prefetchIndex], modalAnnotatedImages[prefetchIndex]]
        .filter(Boolean)
        .forEach(src => { new window.Image().src = src; });
    }
  };
  const handleViewActivation = async (detail) => {
    try {
      setLoadingActivationImage(true);
      const s3Path = detail?.s3ActualPath;
      if (!s3Path) return;
      const [toYear, toMonthNum] = toDate.split("-").map(Number);
      const urls = await generatePresignedUrls([s3Path], toMonthNum, toYear);
      setActivationImageUrl(urls[0] || "");
      setIsActivationImageOpen(true);
    } catch (err) {
      console.error("Failed to load activation image:", err);
    } finally {
      setLoadingActivationImage(false);
    }
  };

  const handleViewCoolerImage = async (s3Path) => {
  try {
    setLoadingCoolerImage(true);
    if (!s3Path) return;
    const [toYear, toMonthNum] = toDate.split("-").map(Number);
    const urls = await generatePresignedUrls([s3Path], toMonthNum, toYear);
    setCoolerImageUrl(urls[0] || "");
    setIsCoolerImageOpen(true);
  } catch (err) {
    console.error("Failed to load cooler image:", err);
  } finally {
    setLoadingCoolerImage(false);
  }
};


  useEffect(() => {
    const fetchStores = async () => {
      if (!salesOfficer || !fromDate || !toDate) {
        setStores([]);
        return;
      }

      setLoadingStores(true);
      setError(null);

      try {
        const [fromYear, fromMonthNum, fromDay] = fromDate.split('-').map(Number);
        const [toYear, toMonthNum, toDay] = toDate.split('-').map(Number);

        const requestBody = {
          from: {
            date: fromDay,
            month: fromMonthNum,
            year: fromYear
          },
          to: {
            date: toDay,
            month: toMonthNum,
            year: toYear
          }
        };
        const soName = salesOfficer.soName;

        const response = await apiClient.post(
          `${API_CONFIG.ENDPOINTS.ASM_REPORT.SO_STORES}/${encodeURIComponent(soName)}`,
          requestBody
        );

        const allStores = [];
        if (Array.isArray(response.data)) {
          response.data.forEach(monthData => {
            if (monthData.stores && Array.isArray(monthData.stores)) {
              monthData.stores.forEach(store => {
                allStores.push({
                  ...store,
                  id: store.storeId,
                  month: monthData.month,
                  year: monthData.year
                });
              });
            }
          });
        }

        setStores(allStores);
        setFilteredStores(allStores);
        setCurrentPage(1);

      } catch (err) {
        console.error("Failed to fetch stores:", err);
        setError("Failed to load stores data.");
        setStores([]);
        setFilteredStores([]);
      } finally {
        setLoadingStores(false);
      }
    };

    fetchStores();
  }, [salesOfficer, fromDate, toDate]);

  // Helper function to download image (Hybrid Approach)
  const handleDownloadImage = async (imageUrl, fileName = "image.jpg") => {
    if (!imageUrl) return;

    try {
      // Attempt to download the image as a blob
      // Removed &time= parameter to prevent S3 signature invalidation
      const response = await fetch(imageUrl, { mode: 'cors', cache: 'no-cache' });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.warn("Direct download failed, opening in new tab:", error);
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = fileName;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

   const handleStoreClick = async (store) => {
   try {
    const month = store.month;
    const year = store.year;
    const monthData = {
      year,
      month,
      label: new Date(year, month - 1).toLocaleString('default', { month: 'long' }),
    };
    setSelectedMonthData(monthData);

    const [fromYear, fromMonthNum, fromDay] = fromDate.split('-').map(Number);
    const [toYear, toMonthNum, toDay] = toDate.split('-').map(Number);
    const requestBody = {
      from: { date: fromDay, month: fromMonthNum, year: fromYear },
      to: { date: toDay, month: toMonthNum, year: toYear }
    };

    // ✅ Both API calls in parallel
    const [res, breakdownRes] = await Promise.all([
      apiClient.post(
        `${API_CONFIG.BASE_URL}/red-master/store-details?storeId=${store.storeId}`,
        requestBody
      ),
      apiClient.post(
        `${API_CONFIG.BASE_URL}/red-master/${store.storeId}/score-breakdown`,
        requestBody
      )
    ]);

    const breakdownData = breakdownRes.data;
    setSelectedStoreDetails(res.data || null);
    setScoreBreakdown(breakdownData);
    setProductSummary(breakdownData?.availability?.products || []);

    const actualPaths        = breakdownData?.availability?.imagePathResponse?.s3pathActualFile     || [];
    const annotatedPaths     = breakdownData?.availability?.imagePathResponse?.s3pathAnnotatedFile  || [];
    const storeImagePaths    = res.data?.imagePaths?.map(path => `${path}`) || [];

    const shelves = actualPaths.map((_, index) => ({
      shelfNumber: index + 1,
      label: `Shelf ${index + 1}`
    }));
    setShelfInfo(shelves);

    // ✅ All 5 presigned URL fetches in parallel
    const [
      actualUrls,
      annotatedUrls,
      storeImageUrls
    ] = await Promise.all([
      actualPaths.length > 0
        ? generatePresignedUrls(actualPaths, month, year)
        : Promise.resolve([]),
      annotatedPaths.length > 0
        ? generatePresignedUrls(annotatedPaths, month, year)
        : Promise.resolve([]),
      storeImagePaths.length > 0
        ? generatePresignedUrls(storeImagePaths, monthData.month, monthData.year)
        : Promise.resolve([]),
    ]);

    
    setSelectedStoreImages(storeImageUrls);
    setModalActualImages(actualUrls);
    setActualImageUrl(actualUrls[0] || "");
    setModalAnnotatedImages(annotatedUrls);
    setAnnotatedImageUrl(annotatedUrls[0] || "");
    setModalImageIndex(0);
    setCurrentImageIndex(0);
    setActiveTab(0);

     actualUrls.slice(0, 3).forEach(src => { new window.Image().src = src; });
     annotatedUrls.slice(0, 3).forEach(src => { new window.Image().src = src; });

  } catch (err) {
    console.error("Failed to load store details:", err);
    setError("Failed to load store details.");
    setSelectedStoreDetails(null);
    setScoreBreakdown(null);
    setProductSummary([]);
    setSelectedStoreImages([]);
    setSelectedMonthData(null);
    setShelfInfo([]);
    setActualImageUrl("");
    setAnnotatedImageUrl("");
  }
};
  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.ResizeObserver === "undefined"
    ) {
      return;
    }
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserverPatched extends (
      OriginalResizeObserver
    ) {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => callback(entries, observer));
        });
      }
    };
    return () => {
      window.ResizeObserver = OriginalResizeObserver;
    };
  }, []);
  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query.trim()) {
      setFilteredStores(stores);
      setCurrentPage(1);
      return;
    }

    const filtered = stores.filter((store) =>
      store.storeName?.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredStores(filtered);
    setCurrentPage(1);
  };


  return (
    <>
      <Flex mt="8" gap={6} flexDir={{ base: "column", lg: "row" }}>
        {/* Stores Section with Search */}
        <Box
          flex="1"
          bg="white"
          borderRadius="xl"
          overflow="hidden"
          boxShadow="sm"
          border="1px solid"
          borderColor="gray.200"
        >
          {/* Search Bar */}
          <Box p={4} borderBottom="1px solid" borderColor="gray.200">
            <Text fontSize="lg" fontWeight="bold" color="gray.800" mb={3}>
              Stores
            </Text>
            <InputGroup maxW="400px">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" />
              </InputLeftElement>
              <Input
                placeholder="Search stores..."
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                bg="white"
                borderColor="gray.300"
                focusBorderColor="red.500"
                _placeholder={{ color: "gray.400" }}
              />
              {searchQuery && (
                <InputRightElement>
                  <IconButton
                    aria-label="Clear search"
                    size="sm"
                    icon={<CloseIcon />}
                    onClick={() => {
                      setSearchQuery("");
                      setFilteredStores(stores);
                    }}
                    variant="ghost"
                  />
                </InputRightElement>
              )}
            </InputGroup>
          </Box>
          {/* Stores Table with Pagination */}
          <Box p={0} height="500px" overflow="hidden">
            {loadingStores ? (
              <Flex justify="center" align="center" height="400px">
                <Spinner size="lg" color="red.600" />
              </Flex>
            ) : (
              <Box height="100%">
                {/* Table Container */}
                <Box height="calc(100% - 60px)" overflow="auto">
                  <TableContainer>
                    <Table variant="simple" size="md">
                      <Thead
                        bg="gray.50"
                        position="sticky"
                        top={0}
                        zIndex={1}
                      >
                        <Tr>
                          <Th
                            fontWeight="bold"
                            color="gray.700"
                            borderColor="gray.200"
                          >
                            Store Name
                          </Th>
                          <Th
                            fontWeight="bold"
                            color="gray.700"
                            borderColor="gray.200"
                          >
                            Actions
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {filteredStores
                          .slice(
                            (currentPage - 1) * pageSize,
                            currentPage * pageSize
                          )
                          .map((store, index) => (
                            <Tr
                              key={store.id || index}
                              role="group"
                              _hover={{ bg: "red.500", color: "white" }}
                              cursor="pointer"
                              onClick={async () => {
                                await handleStoreClick(store);
                              }}
                              bg={
                                selectedStoreDetails?.id === store.id
                                  ? "red.50"
                                  : "transparent"
                              }
                            >
                              <Td borderColor="gray.200">
                                <Text
                                  fontWeight="medium"
                                  color="gray.800"
                                  _groupHover={{ color: "white" }}
                                >
                                  {store.storeName || "-"}
                                </Text>
                              </Td>
                              <Td borderColor="gray.200">
                                <Button
                                  size="sm"
                                  color="red.500"
                                  bg="white"
                                  _groupHover={{
                                    color: "white",
                                    bg: "red.600",
                                  }}
                                  _hover={{
                                    transform: "scale(1.08)",
                                    boxShadow: "lg",
                                  }}
                                  transition="all 0.2s ease-in-out"
                                  colorScheme="red"
                                  variant="outline"
                                  onClick={async (e) => {
                                    e.stopPropagation();
                                    await handleStoreClick(store);
                                  }}
                                >
                                  View
                                </Button>
                              </Td>
                            </Tr>
                          ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
        {/* Store Details Section with Tabs */}
        <Box
          flex="1"
          bg="white"
          borderRadius="xl"
          overflow="hidden"
          boxShadow="sm"
          border="1px solid"
          borderColor="gray.200"
          height="600px"
        >
          <Tabs
            index={activeTab}
            onChange={(index) => setActiveTab(index)}
            height="100%"
          >
            <TabList
              bg="red.100"
              p={2}
              borderRadius="lg"
              gap={2}
              mx={4}
              mt={4}
              display="flex"
              justifyContent="space-between"
            >
              <Tab
                flex="1" // makes full width equally
                fontWeight="semibold"
                fontSize="md"
                py={3}
                borderRadius="lg"
                color="gray.600"
                gap={2}
                justifyContent="center" // center icon + text
                _selected={{
                  bg: "red.600",
                  color: "white",
                  boxShadow: "md",
                }}
                _hover={{
                  bg: "red.100",
                  color: "red.600",
                }}
              >
                <FiGrid size={18} /> Abstract View
              </Tab>
              <Tab
                flex="1"
                fontWeight="semibold"
                fontSize="md"
                py={3}
                borderRadius="lg"
                color="gray.600"
                gap={2}
                justifyContent="center"
                _selected={{
                  bg: "red.600",
                  color: "white",
                  boxShadow: "md",
                }}
                _hover={{
                  bg: "red.100",
                  color: "red.600",
                }}
              >
                <FiList size={18} /> Detail View
              </Tab>
            </TabList>
            <TabPanels height="calc(100% - 73px)" overflowY="auto">
              <TabPanel height="100%" p={4}>
                {selectedStoreDetails ? (
                  <Box height="100%" overflowY="auto">
                    {/* Store Information Section */}
                    <Box mb={6}>
                      <Text
                        fontSize="lg"
                        fontWeight="bold"
                        color="gray.800"
                        mb={4}
                      >
                        Store Details
                      </Text>
                      <Flex
                        direction={{ base: "column", md: "row" }}
                        gap={4}
                        align="stretch"
                        mb={6}
                      >
                        {/* Left: Store Info Card */}
                        <Box
                          p={4}
                          bg="white"
                          borderRadius="xl"
                          border="1px solid"
                          borderColor="gray.200"
                          boxShadow="md"
                          flex="1"
                        >
                          <Heading
                            size="sm"
                            mb={4}
                            color="gray.800"
                            fontWeight="bold"
                          >
                            Store Information
                          </Heading>
                          <VStack align="start" spacing={3}>
                            <HStack align="start" spacing={3}>
                              <Icon
                                as={FiShoppingBag}
                                color="red.600"
                                fontSize="20px"
                              />
                              <Box>
                                <Text
                                  fontSize="xs"
                                  color="gray.500"
                                  fontWeight="medium"
                                >
                                  Store Name
                                </Text>
                                <Text
                                  fontSize="sm"
                                  color="gray.800"
                                  fontWeight="semibold"
                                >
                                  {selectedStoreDetails?.storeName || "-"}
                                </Text>
                              </Box>
                            </HStack>
                            <HStack align="start" spacing={3}>
                              <Icon
                                as={FiTag}
                                color="green.600"
                                fontSize="20px"
                              />
                              <Box>
                                <Text
                                  fontSize="xs"
                                  color="gray.500"
                                  fontWeight="medium"
                                >
                                  Store Type
                                </Text>
                                <Text
                                  fontSize="sm"
                                  color="gray.800"
                                  fontWeight="semibold"
                                >
                                  {selectedStoreDetails?.storeType || "-"}
                                </Text>
                              </Box>
                            </HStack>
                            <HStack align="start" spacing={3}>
                              <Icon
                                as={FiPackage}
                                color="purple.600"
                                fontSize="20px"
                              />
                              <Box>
                                <Text
                                  fontSize="xs"
                                  color="gray.500"
                                  fontWeight="medium"
                                >
                                  Store Class
                                </Text>
                                <Text
                                  fontSize="sm"
                                  color="gray.800"
                                  fontWeight="semibold"
                                >
                                  {selectedStoreDetails?.storeClass || "-"}
                                </Text>
                              </Box>
                            </HStack>
                            {selectedStoreDetails.address && (
                              <HStack align="start" spacing={3}>
                                <Icon
                                  as={FiMapPin}
                                  color="orange.600"
                                  fontSize="20px"
                                />
                                <Box>
                                  <Text
                                    fontSize="xs"
                                    color="gray.500"
                                    fontWeight="medium"
                                  >
                                    Address
                                  </Text>
                                  <Text
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="semibold"
                                  >
                                    {selectedStoreDetails.address}
                                  </Text>
                                </Box>
                              </HStack>
                            )}
                          </VStack>
                        </Box>
                        {/* Right: Store Scores Card */}
                        <Box
                          p={4}
                          bg="white"
                          borderRadius="xl"
                          border="1px solid"
                          borderColor="gray.200"
                          boxShadow="md"
                          flex="1"
                        >
                          <Heading
                            size="sm"
                            mb={4}
                            color="gray.800"
                            fontWeight="bold"
                          >
                            Store Scores
                          </Heading>
                          <SimpleGrid columns={1} spacing={3}>
                            <Box
                              textAlign="center"
                              p={3}
                              bg="green.50"
                              borderRadius="lg"
                              border="1px solid"
                              borderColor="green.200"
                            >
                              <Text
                                fontSize="sm"
                                color="green.700"
                                fontWeight="medium"
                              >
                                Availability
                              </Text>
                              <Text
                                fontSize="lg"
                                fontWeight="bold"
                                color="green.600"
                              >
                                {selectedStoreDetails?.availabilityScore || 0}
                              </Text>
                            </Box>
                            <Box
                              textAlign="center"
                              p={3}
                              bg="yellow.50"
                              borderRadius="lg"
                              border="1px solid"
                              borderColor="yellow.200"
                            >
                              <Text
                                fontSize="sm"
                                color="yellow.700"
                                fontWeight="medium"
                              >
                                Activation
                              </Text>
                              <Text
                                fontSize="lg"
                                fontWeight="bold"
                                color="yellow.600"
                              >
                                {selectedStoreDetails?.activationScore || 0}
                              </Text>
                            </Box>
                            <Box
                              textAlign="center"
                              p={3}
                              bg="red.50"
                              borderRadius="lg"
                              border="1px solid"
                              borderColor="red.200"
                            >
                              <Text
                                fontSize="sm"
                                color="red.700"
                                fontWeight="medium"
                              >
                                Cooler
                              </Text>
                              <Text
                                fontSize="lg"
                                fontWeight="bold"
                                color="red.600"
                              >
                                {selectedStoreDetails?.coolerScore || 0}
                              </Text>
                            </Box>
                            <Box
                              textAlign="center"
                              p={3}
                              bg="blue.50"
                              borderRadius="lg"
                              border="1px solid"
                              borderColor="blue.200"
                              flex={1}
                            >
                              <Text
                                fontSize="sm"
                                color="blue.600"
                                fontWeight="medium"
                              >
                                Cooler Purity
                              </Text>
                              <Text
                                fontSize="lg"
                                fontWeight="bold"
                                color="blue.600"
                              >
                                {selectedStoreDetails?.coolerPurity || 0}
                              </Text>
                            </Box>
                            <Box
                              textAlign="center"
                              p={3}
                              bg="gray.50"
                              borderRadius="lg"
                              border="1px solid"
                              borderColor="gray.200"
                              flex={1}
                            >
                              <Text
                                fontSize="sm"
                                color="gray.600"
                                fontWeight="medium"
                              >
                                Cooler Impurity
                              </Text>
                              <Text
                                fontSize="lg"
                                fontWeight="bold"
                                color="gray.600"
                              >
                                {selectedStoreDetails?.coolerImpurity || 0}
                              </Text>
                            </Box>
                            <Box
                              textAlign="center"
                              p={3}
                              bg="purple.50"
                              borderRadius="lg"
                              border="1px solid"
                              borderColor="purple.200"
                              flex={1}
                            >
                              <Text
                                fontSize="sm"
                                color="purple.700"
                                fontWeight="medium"
                              >
                                Cooler Bonus
                              </Text>
                              <Text
                                fontSize="lg"
                                fontWeight="bold"
                                color="purple.600"
                              >
                                {selectedStoreDetails?.coolerBonus || 0}
                              </Text>
                            </Box>
                          </SimpleGrid>
                        </Box>
                      </Flex>
                    </Box>
                    {/* Store Images Section */}
                    <Box>
                      <Text
                        fontSize="lg"
                        fontWeight="bold"
                        color="gray.800"
                        mb={4}
                      >
                        Store Images
                      </Text>
                      {selectedStoreImages.length > 0 ? (
                        <VStack spacing={4}>
                          {/* Main Image Display */}
                          <Box
                            position="relative"
                            w="full"
                            maxW="480px"
                            mx="auto"
                            borderRadius="xl"
                            overflow="hidden"
                            boxShadow="xl"
                            bg="gray.100"
                          >
                            <Image
                              src={selectedStoreImages[currentImageIndex]}
                              alt={`Store image ${currentImageIndex + 1}`}
                              objectFit="contain"
                              w="100%"
                              h="300px"
                              bg="white"
                            />
                            {/* Download Button Overlay */}
                            <IconButton
                              aria-label="Download image"
                              icon={<FiDownload />}
                              position="absolute"
                              top={2}
                              right={2}
                              colorScheme="red"
                              variant="solid"
                              size="sm"
                              color="white"
                              bg="red.600"
                              boxShadow="md"
                              _hover={{ bg: "red.700" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadImage(selectedStoreImages[currentImageIndex], `store_image_${currentImageIndex + 1}.jpg`);
                              }}
                              zIndex={2}
                            />
                            {/* Navigation Buttons */}
                            {selectedStoreImages.length > 1 && (
                              <>
                                <Button
                                  position="absolute"
                                  left="4"
                                  top="50%"
                                  transform="translateY(-50%)"
                                  onClick={() =>
                                    setCurrentImageIndex(
                                      Math.max(0, currentImageIndex - 1)
                                    )
                                  }
                                  isDisabled={currentImageIndex === 0}
                                  size="sm"
                                  bg="whiteAlpha.900"
                                  boxShadow="md"
                                  _hover={{ bg: "white" }}
                                  zIndex={1}
                                >
                                  <Icon as={FiChevronLeft} boxSize={5} />
                                </Button>
                                <Button
                                  position="absolute"
                                  right="4"
                                  top="50%"
                                  transform="translateY(-50%)"
                                  onClick={() =>
                                    setCurrentImageIndex(
                                      Math.min(
                                        selectedStoreImages.length - 1,
                                        currentImageIndex + 1
                                      )
                                    )
                                  }
                                  isDisabled={
                                    currentImageIndex ===
                                    selectedStoreImages.length - 1
                                  }
                                  size="sm"
                                  bg="whiteAlpha.900"
                                  boxShadow="md"
                                  _hover={{ bg: "white" }}
                                  zIndex={1}
                                >
                                  <Icon as={FiChevronRight} boxSize={5} />
                                </Button>
                              </>
                            )}
                          </Box>
                          {/* Image Counter */}
                          {selectedStoreImages.length > 1 && (
                            <HStack>
                              <Text
                                fontSize="sm"
                                color="gray.600"
                                fontWeight="medium"
                              >
                                {currentImageIndex + 1} /{" "}
                                {selectedStoreImages.length}
                              </Text>
                            </HStack>
                          )}
                          {/* Thumbnails */}
                          {selectedStoreImages.length > 1 && (
                            <HStack
                              spacing={2}
                              overflowX="auto"
                              py={2}
                              justify="center"
                            >
                              {selectedStoreImages.map((img, idx) => (
                                <Box
                                  key={idx}
                                  onClick={() => setCurrentImageIndex(idx)}
                                  cursor="pointer"
                                  opacity={
                                    idx === currentImageIndex ? 1 : 0.5
                                  }
                                  border={
                                    idx === currentImageIndex
                                      ? "2px solid"
                                      : "none"
                                  }
                                  borderColor="red.500"
                                  borderRadius="md"
                                  overflow="hidden"
                                  transition="all 0.2s"
                                  _hover={{ opacity: 0.8 }}
                                >
                                  <Image
                                    src={img}
                                    alt={`thumb ${idx}`}
                                    w="60px"
                                    h="60px"
                                    objectFit="cover"
                                  />
                                </Box>
                              ))}
                            </HStack>
                          )}
                        </VStack>
                      ) : (
                        <Center
                          h="200px"
                          bg="gray.50"
                          borderRadius="xl"
                          border="2px dashed"
                          borderColor="gray.300"
                        >
                          <Text color="gray.500" fontWeight="medium">
                            No store images available
                          </Text>
                        </Center>
                      )}
                    </Box>
                  </Box>
                ) : (
                  <Center height="500px">
                    <Text color="gray.600">
                      Select a store to view details
                    </Text>
                  </Center>
                )}
              </TabPanel>
              {/* Detail View Tab */}
              <TabPanel height="100%" width="100%" p={4}>
                <Box textAlign="center" mt={10}>
                  <Text
                    fontSize="lg"
                    fontWeight="bold"
                    color="gray.800"
                    mb={4}
                  >
                    Detail View
                  </Text>
                  <Text color="gray.600" mb={6}>
                    Click the button below to open detailed view in a popup
                  </Text>
                  <Button
                    colorScheme="red"
                    onClick={onOpen}
                    size="lg"
                    leftIcon={<FiExternalLink />}
                  >
                    Open Detail View
                  </Button>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Flex>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="6xl"
        isCentered
        motionPreset="slideInBottom"
        scrollBehavior="inside"
        blockScrollOnMount={false}
      >
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <ModalContent
          maxH="90vh"
          bg="white"
          borderRadius="2xl"
          boxShadow="2xl"
          overflow="hidden"
        >
          {/* Modern Header with Gradient */}
          <ModalHeader
            bgGradient="linear(to-r, red.600, red.500)"
            color="white"
            py={6}
            px={8}
            borderBottom="1px solid"
            borderColor="red.700"
          >
            <Flex align="center" justify="space-between">
              <Flex align="center" gap={3}>
                <Icon as={MdStorefront} boxSize={7} />
                <Box>
                  <Heading size="md" fontWeight="bold">
                    Store Detail View
                  </Heading>
                  <Text fontSize="sm" color="red.100" mt={1}>
                    Comprehensive store analytics and visual insights
                  </Text>
                </Box>
              </Flex>
              <IconButton
                aria-label="Close modal"
                icon={<FiX />}
                variant="ghost"
                color="white"
                _hover={{ bg: "red.700" }}
                onClick={onClose}
                size="lg"
              />
            </Flex>
          </ModalHeader>
          <ModalBody px={8} py={6} overflowY="scroll">
            {scoreBreakdown ? (
              <VStack spacing={6} align="stretch">
                {/* Store Overview Card */}
                <Box
                  bg="white"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.200"
                  boxShadow="lg"
                  p={6}
                  position="relative"
                  overflow="hidden"
                  _before={{
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "6px",
                    height: "100%",
                    bg: "red.600",
                  }}
                >
                  <Flex align="center" mb={4}>
                    <Icon as={MdStore} color="red.600" boxSize={6} mr={3} />
                    <Heading size="md" color="gray.800" fontWeight="semibold">
                      Store Overview
                    </Heading>
                  </Flex>
                  {(() => {
                    const store = scoreBreakdown.store || {};
                    return (
                      <SimpleGrid
                        columns={{ base: 1, md: 2, lg: 3 }}
                        spacing={6}
                      >
                        <InfoCard
                          icon={FiHash}
                          label="Store ID"
                          value={store.storeId || "-"}
                          color="red"
                        />
                        <InfoCard
                          icon={FiTag}
                          label="Store Code"
                          value={store.storeId || "-"}
                          color="green"
                        />
                        <InfoCard
                          icon={MdStore}
                          label="Store Name"
                          value={store.storeName || "-"}
                          color="purple"
                        />
                        <InfoCard
                          icon={FiPackage}
                          label="Store Type - Store Class"
                          value={`${store.storeType || "-"} - ${store.storeClass || "-"}`}
                          color="orange"
                        />
                        <InfoCard
                          icon={FiPackage}
                          label="Cooler Size"
                          value={store.coolerSize || "-"}
                          color="blue"
                        />
                        <InfoCard
                          icon={FiMapPin}
                          label="Address"
                          value={store.storeAddress || "-"}
                          color="red"
                          colSpan={{ base: 1, md: 2, lg: 3 }}
                        />
                      </SimpleGrid>
                    );
                  })()}
                </Box>
                {/* Main Content Grid - Two Column Layout */}
                <Grid
                  templateColumns={{ base: "1fr", lg: "1fr" }}
                  gap={6}
                  minH="500px"
                >
                  {/* Left Column - Product Summary */}
                  <Box
                    bg="white"
                    borderRadius="xl"
                    border="1px solid"
                    borderColor="gray.200"
                    boxShadow="lg"
                    p={6}
                    display="flex"
                    flexDirection="column"
                    height="100%"
                  >
                    <Flex align="center" justify="space-between" mb={4}>
                      <Flex align="center">
                        <Icon as={FiGrid} color="red.600" boxSize={6} mr={3} />
                        <Heading
                          size="md"
                          color="gray.800"
                          fontWeight="semibold"
                        >
                          Product Summary
                        </Heading>
                      </Flex>
                      <HStack spacing={3} align="center">
                        <Badge colorScheme="green" fontSize="15px" variant="subtle" px={4} py={2} >
                          availability Score:
                          {scoreBreakdown?.availability?.availabilityScore ? `${scoreBreakdown.availability.availabilityScore} out of 70` : "0:out of 70"}

                        </Badge>
                        <Badge colorScheme="red" fontSize="md" variant="subtle" px={3} py={1} borderRadius="full">
                          {productSummary.length} items
                        </Badge>
                      </HStack>
                    </Flex>
                    <Box>
                      {productSummary.length > 0 ? (
                        <Box
                          borderRadius="lg"
                          overflow="hidden"
                          border="1px solid"
                          borderColor="gray.200"
                        >
                          <ProductTable productSummary={productSummary} />
                        </Box>
                      ) : (
                        <Center h="400px">
                          <VStack spacing={3}>
                            <Icon
                              as={FiPackage}
                              boxSize={12}
                              color="gray.400"
                            />
                            <Text color="gray.600" fontWeight="medium">
                              No products found
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                              No product data available for this store
                            </Text>
                          </VStack>
                        </Center>
                      )}
                    </Box>
                  </Box>
                  {/* Right Column - Images */}
                  <Box
                    bg="white"
                    borderRadius="xl"
                    border="1px solid"
                    borderColor="gray.200"
                    boxShadow="lg"
                    p={6}
                    display="flex"
                    flexDirection="column"
                    height="100%"
                  >
                    <Flex align="center" justify="space-between" mb={4}>
                      <Flex align="center">
                        <Icon as={FiImage} color="red.600" boxSize={6} mr={3} />
                        <Heading size="md" color="gray.800" fontWeight="semibold">
                          Visual Evidence
                        </Heading>
                      </Flex>
                      {shelfInfo.length > 0 && shelfInfo[modalImageIndex] && (
                        <Badge
                          colorScheme="red"
                          fontSize="md"
                          px={4}
                          py={2}
                          borderRadius="full"
                          fontWeight="bold"
                        >
                          {shelfInfo[modalImageIndex].label}
                        </Badge>
                      )}
                    </Flex>
                    <HStack spacing={6} flex={1}>
                      {/* Actual Image Card */}
                      <ImageCard
                        title="Actual Image"
                        subtitle="Original store photograph"
                        icon={FiEye}
                        imageUrl={actualImageUrl}
                        colorScheme="red"
                      />
                      {/* Annotated Image Card */}
                      {!isOrgUser && (
                        <ImageCard
                          title="Annotated Image"
                          subtitle="AI-processed analysis"
                          icon={FiCheckCircle}
                          imageUrl={annotatedImageUrl}
                          colorScheme="green"
                        />
                      )}
                    </HStack>
                    {/* Navigation controls for Visual Evidence */}
                    <HStack justify="center" mt={4} spacing={4}>
                      <IconButton
                        aria-label="Previous image"
                        icon={<FiChevronLeft />}
                        onClick={handlePrevModalImage}
                        isDisabled={modalImageIndex <= 0}
                      />
                      <Text fontSize="sm" color="gray.600">
                        {modalActualImages.length > 0 ? `${modalImageIndex + 1} / ${modalActualImages.length}` : "0 / 0"}
                      </Text>
                      <IconButton
                        aria-label="Next image"
                        icon={<FiChevronRight />}
                        onClick={handleNextModalImage}
                        isDisabled={modalImageIndex >= Math.max(0, modalActualImages.length - 1)}
                      />
                    </HStack>
                  </Box>
                </Grid>
                {/* Cooler Section */}
                <Box
                  bg="white"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.200"
                  boxShadow="lg"
                  p={6}
                >
                  <Flex align="center" justify="space-between" mb={4}>
                    <Flex align="center">
                      <Icon as={FiPackage} color="red.600" boxSize={6} mr={3} />
                      <Heading size="md" color="gray.800" fontWeight="semibold">
                        Cooler Breakdown
                      </Heading>
                    </Flex>
                    <Badge colorScheme="red" variant="solid" px={4} py={2} fontSize="md">
                      Total Cooler Score: {scoreBreakdown?.cooler?.coolerScore ? `${scoreBreakdown.cooler.coolerScore} out of ${scoreBreakdown?.cooler?.maxScore}` : `0 out of ${scoreBreakdown?.cooler?.maxScore}`}
                    </Badge>
                  </Flex>
                  {/* Cooler Visibility Section */}
               <Box mt={2} mb={6}>
                <Flex align="center" mb={4}>
                  <Icon as={FiEye} color="red.600" boxSize={5} mr={3} />
                  <Heading size="sm" color="gray.800" fontWeight="semibold">
                    Cooler Visibility
                  </Heading>
                </Flex>
                  {scoreBreakdown?.cooler?.coolerPosition ? (
                    <TableContainer>
                      <Table variant="simple">
                        <Thead bg="red.50">
                          <Tr>
                            <Th color="red.700" fontWeight="bold" w="35%">Metric Name</Th>
                            <Th color="red.700" fontWeight="bold" w="20%" textAlign="center">Value</Th>
                            <Th color="red.700" fontWeight="bold" w="25%" textAlign="center">Action</Th>
                            <Th color="red.700" fontWeight="bold" w="20%" textAlign="center">Points</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          <Tr>
                            <Td fontWeight="medium">{scoreBreakdown.cooler.coolerPosition.metricName}</Td>
                            <Td textAlign="center">{scoreBreakdown.cooler.coolerPosition.value}</Td>
                            <Td textAlign="center">
                              <Button
                                size="sm"
                                colorScheme="red"
                                variant="outline"
                                leftIcon={<FiEye />}
                                isDisabled={!scoreBreakdown.cooler.coolerPosition.fileName}
                                isLoading={loadingCoolerImage}
                                onClick={() => handleViewCoolerImage(scoreBreakdown.cooler.coolerPosition.fileName)}
                              >
                                View
                              </Button>
                            </Td>
                            <Td textAlign="center" color="green.600" fontWeight="bold">
                              {scoreBreakdown.cooler.coolerPosition.points}
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Center h="100px" color="gray.500">No visibility data available</Center>
                  )}
                </Box>

                 <Box mt={2} mb={6}>
                <Flex align="center" mb={4}>
                  <Icon as={FiEye} color="red.600" boxSize={5} mr={3} />
                  <Heading size="sm" color="gray.800" fontWeight="semibold">
                    Cooler Shelf BreakDown
                  </Heading>
                </Flex>
                  {scoreBreakdown?.cooler?.shelfWiseCounts?.length > 0 ? (
                    <>
                      <TableContainer>
                        <Table variant="simple">
                          <Thead bg="red.50">
                            <Tr>
                              <Th color="red.700" fontWeight="bold" w="30%">
                              Shelf Number</Th>
                              <Th color="red.700" fontWeight="bold" w="30%">
                              Status                  
                            </Th>
                            <Th color="red.700" fontWeight="bold" w="40%" textAlign="center">Actual Counts </Th>
                              <Th color="red.700" fontWeight="bold" w="40%" textAlign="center">Product Percentage </Th>
                             <Th color="red.700" fontWeight="bold" w="20%" textAlign="center">Points</Th>
                           </Tr>
                          </Thead>
                          <Tbody>
                            {scoreBreakdown.cooler.shelfWiseCounts.map((shelf, idx) => (
                              <Tr key={idx}>
                                <Td fontWeight="medium">{shelf.shelfNumber}</Td>
                                 <Td>
                                 <Badge colorScheme={shelf.status?.toUpperCase()==="PURE"?"green":"red"}
                                  variant="solid"
                                  px={3 }Py={1}
                                  borderRadius="full"
                                  fontWeight="bold"
                                >
                                 {shelf.status}
                               </Badge>              
                                </Td>
                                 <Td textAlign="center" color="green.600" fontWeight="bold">{shelf.productCount}</Td>
                                <Td  textAlign="center" color="green.600" fontWeight="bold">{shelf.result}</Td>
                              <Td colo>{shelf.points}</Td> 
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : (
                    <Center h="200px" color="gray.500">
                      No cooler data available
                    </Center>
                  )}
                  </Box>
                </Box>
              </VStack>
            ) : (
              <Center h="400px">
                <VStack spacing={4}>
                  <Icon as={MdStore} boxSize={16} color="gray.400" />
                  <Text fontSize="lg" color="gray.600" fontWeight="semibold">
                    No Store Data Available
                  </Text>
                  <Text color="gray.500" textAlign="center" maxW="md">
                    Select a store and open detail view to see comprehensive
                    analytics
                  </Text>
                </VStack>
              </Center>
            )}
             {/* Activation Section */}
                <Box
                  bg="white"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.200"
                  boxShadow="lg"
                  p={6}
                >
                  <Flex align="center" justify="space-between" mb={4}>
                    <Flex align="center">
                      <Icon as={FiCheckCircle} color="yellow.600" boxSize={6} mr={3} />
                      <Heading size="md" color="gray.800" fontWeight="semibold">
                        Activation Details
                      </Heading>
                    </Flex>
                    <Badge colorScheme="blue"  fontSize= "md" variant="solid" px={4} py={2}>
                      activationScore: 
                      {scoreBreakdown?.activation?.activationScore ? `${scoreBreakdown.activation.activationScore} out of 10` : "0 out of 10"}
                    </Badge>
                  </Flex>
                  {scoreBreakdown?.activation?.activationDetails?.length > 0 ? (
                    <TableContainer>
                      <Table variant="simple">
                        <Thead bg="yellow.50">
                          <Tr>
                            <Th color="yellow.700" fontWeight="bold">Company</Th>
                            <Th color="yellow.700" fontWeight="bold">Brand</Th>
                            <Th color="yellow.700" fontWeight="bold">Product</Th>
                            <Th color="yellow.700" fontWeight="bold">Action</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {scoreBreakdown.activation.activationDetails.map((detail, idx) => (
                            <Tr key={idx} bg={idx % 2 === 0 ? "yellow.50" : "transparent"}>
                              <Td fontWeight="medium">{detail.product?.productCompany?.productCompanyName || "-"}</Td>
                              <Td>{detail.product?.productBrand?.productBrandName || "-"}</Td>
                              <Td>{detail.product?.productName || "-"}</Td>
                              <Td>
                                <Button size="sm" colorScheme="yellow" onClick={() => handleViewActivation(detail)}>
                                  View
                                </Button>
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Center h="200px" color="gray.500">
                      No activation details available
                    </Center>
                  )}
                </Box>
          </ModalBody>
          {/* Modern Footer */}
          <ModalFooter
            px={8}
            py={4}
            bg="gray.50"
            borderTop="1px solid"
            borderColor="gray.200"
          >
            <Flex w="100%" justify="space-between" align="center">
              <Text fontSize="sm" color="gray.600">
                &copy; 2025 Image Insight. All rights reserved.
              </Text>
              <HStack spacing={3}>
                <Button
                  variant="outline"
                  colorScheme="gray"
                  leftIcon={<FiX />}
                  onClick={onClose}
                  size="lg"
                  px={8}
                  borderRadius="lg"
                >
                  Close
                </Button>
              </HStack>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Activation Image Modal */}
      <Modal isOpen={isActivationImageOpen} onClose={() => setIsActivationImageOpen(false)} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Activation Image</ModalHeader>
          <ModalBody>
            {loadingActivationImage ? (
              <Center py={8}>
                <Spinner />
              </Center>
            ) : activationImageUrl ? (
              <Image src={activationImageUrl} alt="Activation" width="100%" borderRadius="md" maxH="500px" objectFit="contain" />
            ) : (
              <Center py={8} color="gray.600">No image available</Center>
            )}
          </ModalBody>
          <ModalFooter>
            {activationImageUrl && (
              <Button
                leftIcon={<FiDownload />}
                colorScheme="red"
                mr={3}
                onClick={() => handleDownloadImage(activationImageUrl, "activation_image.jpg")}
              >
                Download
              </Button>
            )}
            <Button onClick={() => setIsActivationImageOpen(false)}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Cooler Image Modal */}
      <Modal isOpen={isCoolerImageOpen} onClose={() => setIsCoolerImageOpen(false)} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cooler Position Image</ModalHeader>
          <ModalBody>
            {loadingCoolerImage ? (
              <Center py={8}>
                <Spinner />
              </Center>
            ) : coolerImageUrl ? (
              <Image
                src={coolerImageUrl}
                alt="Cooler position"
                width="100%"
                maxH="500px"
                objectFit="contain"
                borderRadius="md"
              />
            ) : (
              <Center py={8} color="gray.600">No image available</Center>
            )}
          </ModalBody>
          <ModalFooter>
            {coolerImageUrl && (
              <Button
                leftIcon={<FiDownload />}
                colorScheme="red"
                mr={3}
                onClick={() => handleDownloadImage(coolerImageUrl, "cooler_position_image.jpg")}
              >
                Download
              </Button>
            )}
            <Button onClick={() => setIsCoolerImageOpen(false)}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

    </>
  );
}
export default ViewDetails;
